// useComposerModels.js — WRAPPER FINO de useUnifiedModels.
//
// Sprint unified-models: a agregação real (MODEL_REGISTRY + adapters +
// presets + connected status) vive em useUnifiedModels (fonte canônica).
// Este hook mantém o shape legado que ModelDropdown/CodeComposer/
// SessionComposer esperam: { groups, loading, adapters, labelForModel }.
//
// Multi-LLM zero-diff guard: NUNCA toca em modelRegistry.js.

import { useMemo } from 'react';
import { useUnifiedModels } from './useUnifiedModels.js';

export function useComposerModels() {
  const unified = useUnifiedModels({ kind: 'text' });

  return useMemo(() => {
    const { groups, byId, loading, adapters } = unified;

    // labelForModel: byId primeiro (ids canônicos), fallback pra ids legados
    // `adapter:<uuid>[:model]` que possam estar salvos no store de sessões
    // antigas (antes da unificação).
    function labelForModel(modelId) {
      if (!modelId) return null;
      if (byId[modelId]) return byId[modelId].label;
      if (modelId.startsWith('adapter:')) {
        const rest = modelId.slice('adapter:'.length);
        const rawId = rest.split(':')[0];
        const sub = rest.includes(':') ? rest.split(':').slice(1).join(':') : '';
        const ad = (adapters || []).find((a) => a.id === rawId);
        if (ad) {
          const name = ad.display_name || ad.name || 'Adapter';
          return sub ? `${name} · ${sub}` : name;
        }
      }
      return modelId;
    }

    return { groups, loading, adapters, labelForModel };
  }, [unified]);
}
